import React, { Component } from 'react';
import donneesConcours from '../../data/donneesConcours';
import ButtonLink from '../../components/commun/ButtonLink';
import { Link } from 'react-router-dom';
import { Steps } from 'antd';
import victory from '../../images/victory.jpg';
import { prochainObjectif, messageErreur } from './logiqueConcours';
import { addGameContest, addAttemptGameContest, addGame, addFirstName, readFirstName, readInfoContest } from '../../components/commun/localStorage';
import SousMenu from '../../components/principal/SousMenu';
import Prenom from '../../components/commun/Prenom';
import Ad from '../../components/commun/adSense';
import confetti from '../../images/confetti.webp';
import applause from '../../images/applause.webp';
import Confetti from "react-confetti";
import withRouter from '../../components/commun/withRouter';
import { creerEtape } from './logiqueConcours';


class FinEtape extends Component {

    constructor(props) {
        super();
        this.donneesJeu = props.donneesJeu;
        this.nbFautes = props.nbFautes;
        this.temps = props.temps;
        this.perdu = props.perdu;
        this.score = props.score;
        this.concours = null;
        this.erreur = false;
        this.prenomVisible = false;
        this.tentative = 1;

        this.concours = donneesConcours.find(x => x.id === this.donneesJeu.idConcours);

        if (this.concours == null) {
            this.erreur = true;
        }
        else {
            this.victoire = this.verificationVictoire();
            this.jeuSuivant = this.rechercheProchainJeu();
             let infoContest = readInfoContest(this.concours.id);
    
                if (this.victoire) {


                    if (this.jeuSuivant.id !== -1) {
                        addGameContest(this.concours.id, this.jeuSuivant.indexEnCours + 1)
                    }
                    else {   
                        this.tentative = infoContest.attempt;
                        if (this.tentative === 1)
                        {
                           this.verifierPrenom();
                        }
                        
                         addGame('defiorthographe', this.donneesJeu.idConcours);
                         addGameContest(this.concours.id, 0)  //reset si gagné
                        
                    }
                }
                else {
                   addAttemptGameContest(this.concours.id);
                }
          
       }
        this.state = { erreur: this.erreur };
    }

    componentDidMount = () => {

    }
    verifierPrenom = () => {
        const prenom = readFirstName();

         if (prenom === null) {
            this.prenomVisible = true;
         }
         else {
             this.envoyerMessage(prenom);
        }
    }

    callbackPrenom = (prenom) => {
        addFirstName(prenom);
         this.envoyerMessage(prenom);

    }

    verificationVictoire() {

        if ((this.perdu !== undefined && !this.perdu) ||
            (this.nbFautes !== undefined && this.donneesJeu.qualifFaute !== undefined && this.nbFautes <= this.donneesJeu.qualifFaute) ||
            (this.temps !== undefined && this.donneesJeu.qualifTemps !== undefined && this.temps <= this.donneesJeu.qualifTemps) ||
            (this.score !== undefined && this.donneesJeu.qualifScore !== undefined && this.score >= this.donneesJeu.qualifScore)) {
            return true;
        }


        return false;

    }

    envoyerMessage = (prenom) =>
    {
        let url = new URL(process.env.REACT_APP_URL_AJOUTERTABLEAU);
        var data = new FormData();
        data.append('prenom', prenom);
        data.append('noDefi', this.concours.id)
        fetch(url, {
            method: "POST",
            body: data
        })
    }

    rechercheProchainJeu() {
        let jeuSuivant = { type: '', id: -1, titre: '', index: -1 }
        let index = this.concours.liste.findIndex(x => x.id === this.donneesJeu.id);
        if (index === -1) {
            this.erreur = true;
        }
        if (!this.victoire)
        {
            jeuSuivant = this.concours.liste[index]
        }
        else if (index < this.concours.liste.length - 1)
        {
            jeuSuivant = this.concours.liste[index + 1];
        }

        return { ...jeuSuivant, indexEnCours: index };
    }



    render() {
        return <div>
            {this.state.erreur ? <div className="centre"><ButtonLink titre='Désolé, il y a un problème' href={'/'}></ButtonLink><p>Il est préférable de réaliser les exercices dans l'ordre pour ne pas avoir de message d'erreur.</p><p>Il ne faut pas recharger la page pour refaire l'exercice.</p></div> : 
            <div>{this.victoire ?   
                this.jeuSuivant.id !== -1 ? <div className="centre">
                      <div><img className="resp" src={confetti} alt="concours"></img></div>
                    <h1 className="animationSuite couleur">Parfait, tu es qualifié pour le test suivant.</h1>
                      <div className='source'>
    
          </div>
                    <p><ButtonLink titre="Commencer le jeu" href={'/' + this.jeuSuivant.type + '/' + this.jeuSuivant.id}></ButtonLink></p>
                    <p>Objectif prochain test : <b>{prochainObjectif(this.jeuSuivant.id)}</b></p>
                </div>

                    : <div className="centre">
                           <div><img className="resp" src={applause} alt="applaudissement"></img></div>
                        <div className="animationSuite"><p className="grandeLettre couleur">Bravo ! Tu as réussi le défi.</p>
                    <h1>{this.concours.titre}</h1></div>
                        <p>Tu as eu besoin de <b>{this.tentative} {this.tentative <= 1 ? "tentative" : "tentatives"}</b>.</p><img className="img-responsive" src={victory} alt="victoire"></img>
                    {this.tentative === 1 && <div> <Confetti width={window.innerWidth - 30} height={300} /><p className="tailleMoyenne">Félicitations, tu as réussi en une seule tentative, tu es désormais sur notre <b>tableau d'honneur</b> sur la page d'accueil du site.</p></div>}
                        {this.prenomVisible && <Prenom callbackPrenom={this.callbackPrenom}></Prenom>
                        }<div className="espaceHaut"><Ad></Ad></div></div>
                : <div className="centre"><p className="couleur"><b>Malheureusement, tu n'as pas réussi le test.</b></p>
                <p>{messageErreur(this.donneesJeu.id)}</p>
                    <p>Tu peux recommencer.</p>
                    <div><Link className="jeuSuivant" reloadDocument titre='Refaire le défi' href={'/' + this.jeuSuivant.type + '/' + this.jeuSuivant.id}>Refaire le défi</Link></div></div>}
                <div className="margeStep">
               
                    <Steps size="small" current={this.victoire ? this.jeuSuivant.indexEnCours + 1 : this.jeuSuivant.indexEnCours} items={creerEtape(this.concours.liste)}>
                   
                   </Steps>
   
                    <p className="centre espaceHaut30">Ta progression est automatiquement sauvegardée.</p>
                </div>
                {this.jeuSuivant.id === -1 && <div className="centre">  <SousMenu type='defigrammaire' titre="Les défis de l'orthographe, de la grammaire et de la conjugaison"></SousMenu>
          <div className='espaceHaut'></div>
          <SousMenu type='defijeux' titre="Les défis des jeux de lettres et de mots"></SousMenu>
               <p className="espaceHaut30">Tu aimes les jeux de lettres et de mots ? Viens participer à notre <a href="https://concours.evalquiz.com">challenge des mots.</a>.</p>
                <Link className="jeuSuivant" to={"/jeu/"}>Les autres exercices</Link></div>}
            </div>}
        </div>
    }
} 
export default withRouter(FinEtape);